<template>
  <div>
    <div class="crumb-container">
      您当前所在位置：{{menuPath | formatPath}}
    </div>
  </div>
</template>
<script>
  import global from "@/mixins/global";
  export default {
    mixins: [global],
    filters: {
      formatPath(v) {
        if (Array.isArray(v) && v.length > 0) {
          return v.join(' / ')
        } else {
          return ''
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .tips {
    background: #FFF6DF;
    padding: 8px 20px;
    border-radius: 4px;
    color: #F57100;
    margin-bottom: 20px;
    font-family: 600;
    border-radius: 4px;
    display: flex;
    align-items: center;
    i {
      width: 16px;
      height: 16px;
      display: inline-block;
      background: url('https://hzwimspic-1251601690.image.myqcloud.com/1/3b171160-beaa-11ef-a066-f37d37327794_size_24x24') no-repeat center center;
      background-size: 100% 100%;
      margin-right: 8px;
    }
  }
  .crumb-container {
    width: 100%;
    padding: 10px;
    // background: #ffffff;
    font-size: 14px;
    margin-bottom: 10px;
    color: #000000;
  }
</style>
